import Vue from 'vue'
import Router from 'vue-router'
import _get from 'lodash/get'
import { vueRoutes } from '@/vue-router/routes'
import { store, vuexTypes } from '@/vuex'

import AppContent from '@/vue/AppContent'

import LogsPage from '@/vue/pages/LogsPage'
import LogsList from '@/vue/pages/logs/LogsList'
import LogDetails from '@/vue/pages/logs/LogDetails'

import AdminsPage from '@/vue/pages/AdminsPage'
import AdminsList from '@/vue/pages/admins/AdminsList'
import AdminsManager from '@/vue/pages/admins/AdminsManager'

import UsersPage from '@/vue/pages/UsersPage'
import UsersList from '@/vue/pages/users/UsersList'
import User from '@/vue/pages/users/User'
import UserDetails from '@/vue/pages/users/User.Details'
import UserVerificationComments from '@/vue/pages/users/User.VerificationComments'
import UserVerifications from '@/vue/pages/users/User.Verifications'
import UserTransactions from '@/vue/pages/users/User.Transactions'
import UserCDDs from '@/vue/pages/users/User.CDDs'
import UserBDDs from '@/vue/pages/users/User.BDDs'
import UserBusinessList from '@/vue/pages/users/User.BusinessList'

import BusinessList from '@/vue/pages/businesses/BusinessList'
import BusinessesPage from '@/vue/pages/BusinessesPage'
import BusinessDetails from '@/vue/pages/businesses/BusinessDetails'

import AnnouncementsPage from '@/vue/pages/AnnouncementsPage'
import AnnouncementList from '@/vue/pages/announcements/AnnouncementList'
import AnnouncementDetails from '@/vue/pages/announcements/AnnouncementDetail'

import SupportedNetworksPage from '@/vue/pages/SupportedNetworksPage'
import SupportedNetworksList from '@/vue/pages/supported-networks/SupportedNetworks.List'

import VerificationsPage from '@/vue/pages/VerificationsPage'
import VerificationsList from '@/vue/pages/verifications/VerificationsList'
import VerificationDetails from '@/vue/pages/verifications/VerificationDetails'

import QuickbuyPage from '@/vue/pages/QuickbuyPage'
import QuickbuyVerificationsList from '@/vue/pages/quickbuy/QuickbuyVerificationsList'
import QuickbuyVerificationDetails from '@/vue/pages/quickbuy/QuickbuyVerificationDetails'

import RolesPage from '@/vue/pages/RolesPage'
import RolesList from '@/vue/pages/roles/RolesList'
import RoleDetails from '@/vue/pages/roles/RoleDetails'
import RoleCreate from '@/vue/pages/roles/RoleCreate'

import AdminActionsPage from '@/vue/pages/AdminActionsPage'

import DashboardPage from '@/vue/pages/DashboardPage'
import Dashboard from '@/vue/pages/dashboard/Dashboard'

import WidgetAccessKeyPage from '@/vue/pages/WidgetAccessKeyPage'
import WidgetAccessKeyList from '@/vue/pages/widget-access-key/WidgetAccessKeyList'

import FeatureFlags from '@/vue/pages/feature-flags/FeatureFlags'
import PermissionTransactions from '@/vue/pages/permission-transactions/PermissionTransactions'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/',
    },
    {
      path: '/auth',
      name: vueRoutes.auth.name,
      redirect: vueRoutes.login,
      component: resolve => require(['@/vue/pages/Auth'], resolve),
      children: [
        {
          path: '/sign-in',
          name: vueRoutes.login.name,
          component: resolve => require(['@/vue/pages/Login'], resolve),
          beforeEnter: authPageGuard,
        },
      ],
    },
    {
      path: '/',
      name: vueRoutes.app.name,
      meta: { isNavigationRendered: true },
      component: AppContent,
      beforeEnter: redirectRouteGuard,
      children: [
        {
          path: '/dash',
          name: vueRoutes.dashboard.name,
          meta: {
            pageNameTranslationId: 'pages-names.dash',
          },
          component: DashboardPage,
          redirect: vueRoutes.dashboard,
          beforeEnter: inAppRouteGuard,
          children: [
            {
              path: '/dash',
              name: vueRoutes.dashboard.name,
              component: Dashboard,
              beforeEnter: inAppRouteGuard,
            },
          ],
        },
        {
          path: '/logs',
          name: vueRoutes.logs.name,
          meta: {
            pageNameTranslationId: 'pages-names.logs',
          },
          component: LogsPage,
          redirect: vueRoutes.logsList,
          beforeEnter: inAppRouteGuard,
          children: [
            {
              path: '/logs/list',
              name: vueRoutes.logsList.name,
              component: LogsList,
              beforeEnter: inAppRouteGuard,
            },
            {
              path: '/logs/:id',
              name: vueRoutes.logDetails.name,
              component: LogDetails,
              props: true,
              beforeEnter: inAppRouteGuard,
            },
          ],
        },
        {
          path: '/admins',
          name: vueRoutes.admins.name,
          meta: {
            pageNameTranslationId: 'pages-names.admins',
          },
          component: AdminsPage,
          redirect: vueRoutes.adminsList,
          beforeEnter: inAppRouteGuard,
          children: [
            {
              path: '/admins/list',
              name: vueRoutes.adminsList.name,
              component: AdminsList,
              beforeEnter: inAppRouteGuard,
            },
            {
              path: '/admins/manager/add',
              name: vueRoutes.adminsManagerAdd.name,
              component: AdminsManager,
              beforeEnter: inAppRouteGuard,
            },
            {
              path: '/admins/:id',
              name: vueRoutes.adminDetails.name,
              component: UserDetails,
              props: true,
              beforeEnter: inAppRouteGuard,
            },
          ],
        },
        {
          path: '/businesses',
          name: vueRoutes.businesses.name,
          meta: {
            pageNameTranslationId: 'pages-names.businesses',
          },
          component: BusinessesPage,
          redirect: vueRoutes.businessList,
          beforeEnter: inAppRouteGuard,
          children: [
            {
              path: '/businesses',
              name: vueRoutes.businessList.name,
              component: BusinessList,
              beforeEnter: inAppRouteGuard,
            },
            {
              path: '/businesses/:id',
              name: vueRoutes.businessDetails.name,
              component: BusinessDetails,
              props: true,
              beforeEnter: inAppRouteGuard,
            },
          ],
        },
        {
          path: '/users',
          name: vueRoutes.users.name,
          meta: {
            pageNameTranslationId: 'pages-names.users',
          },
          component: UsersPage,
          redirect: vueRoutes.usersList,
          beforeEnter: inAppRouteGuard,
          children: [
            {
              path: '/users/list',
              name: vueRoutes.usersList.name,
              component: UsersList,
              beforeEnter: inAppRouteGuard,
            },
            {
              path: '/users/:id',
              name: vueRoutes.user.name,
              component: User,
              redirect: vueRoutes.userDetails,
              props: true,
              beforeEnter: inAppRouteGuard,
              children: [
                {
                  path: 'details',
                  name: vueRoutes.userDetails.name,
                  component: UserDetails,
                  props: true,
                  beforeEnter: inAppRouteGuard,
                },
                {
                  path: 'verifications',
                  name: vueRoutes.userVerifications.name,
                  component: UserVerifications,
                  props: true,
                  beforeEnter: inAppRouteGuard,
                },
                {
                  path: 'cdds',
                  name: vueRoutes.userCDDs.name,
                  component: UserCDDs,
                  props: true,
                  beforeEnter: inAppRouteGuard,
                },
                {
                  path: 'bdds',
                  name: vueRoutes.userBDDs.name,
                  component: UserBDDs,
                  props: true,
                  beforeEnter: inAppRouteGuard,
                },
                {
                  path: 'business-list',
                  name: vueRoutes.userBusinessList.name,
                  component: UserBusinessList,
                  props: true,
                  beforeEnter: inAppRouteGuard,
                },
                {
                  path: 'transactions',
                  name: vueRoutes.userTransactions.name,
                  component: UserTransactions,
                  props: true,
                  beforeEnter: inAppRouteGuard,
                },
                {
                  path: 'verification-comments',
                  component: UserVerificationComments,
                  name: vueRoutes.userVerificationComments.name,
                  props: true,
                  beforeEnter: inAppRouteGuard,
                },
              ],
            },
          ],
        },
        {
          path: '/verifications',
          name: vueRoutes.verifications.name,
          meta: {
            pageNameTranslationId: 'pages-names.verifications',
          },
          component: VerificationsPage,
          redirect: vueRoutes.verificationsList,
          beforeEnter: inAppRouteGuard,
          children: [
            {
              path: '/verifications/list',
              name: vueRoutes.verificationsList.name,
              component: VerificationsList,
              beforeEnter: inAppRouteGuard,
            },
            {
              path: '/verification/:id',
              name: vueRoutes.verificationDetails.name,
              component: VerificationDetails,
              props: true,
              beforeEnter: inAppRouteGuard,
            },
            {
              path: '/verification/:id/export',
              name: vueRoutes.verificationDetailsExport.name,
              component: VerificationDetails,
              props: true,
              beforeEnter: inAppRouteGuard,
            },
          ],
        },
        {
          path: '/announcements',
          name: vueRoutes.announcements.name,
          meta: {
            pageNameTranslationId: 'pages-names.announcements',
          },
          component: AnnouncementsPage,
          redirect: vueRoutes.announcementList,
          beforeEnter: inAppRouteGuard,
          children: [
            {
              path: '/announcements',
              name: vueRoutes.announcementList.name,
              component: AnnouncementList,
              beforeEnter: inAppRouteGuard,
            },
            {
              path: '/announcements/:id',
              name: vueRoutes.announcementDetails.name,
              component: AnnouncementDetails,
              props: true,
              beforeEnter: inAppRouteGuard,
            },
          ],
        },
        {
          path: '/quickbuy',
          name: vueRoutes.quickbuy.name,
          meta: {
            pageNameTranslationId: 'pages-names.quickbuy',
          },
          component: QuickbuyPage,
          redirect: vueRoutes.quickbuyVerifications,
          beforeEnter: inAppRouteGuard,
          children: [
            {
              path: '/quickbuy/verifications',
              name: vueRoutes.quickbuyVerifications.name,
              component: QuickbuyVerificationsList,
              beforeEnter: inAppRouteGuard,
            },
            {
              path: '/quickbuy/verification/:id',
              name: vueRoutes.quickbuyVerificationDetails.name,
              component: QuickbuyVerificationDetails,
              props: true,
              beforeEnter: inAppRouteGuard,
            },
          ],
        },
        {
          path: '/supported-networks',
          name: vueRoutes.supportedNetworks.name,
          meta: {
            pageNameTranslationId: 'pages-names.supported-networks',
          },
          component: SupportedNetworksPage,
          redirect: vueRoutes.supportedNetworksList,
          beforeEnter: inAppRouteGuard,
          children: [
            {
              path: '/supported-networks',
              name: vueRoutes.supportedNetworksList.name,
              component: SupportedNetworksList,
              beforeEnter: inAppRouteGuard,
            },
          ],
        },
        {
          path: '/roles',
          name: vueRoutes.roles.name,
          meta: {
            pageNameTranslationId: 'pages-names.roles',
          },
          component: RolesPage,
          redirect: vueRoutes.rolesList,
          beforeEnter: inAppRouteGuard,
          children: [
            {
              path: '/roles/list',
              name: vueRoutes.rolesList.name,
              component: RolesList,
              beforeEnter: inAppRouteGuard,
            },
            {
              path: '/role/:id',
              name: vueRoutes.roleDetails.name,
              component: RoleDetails,
              props: true,
              beforeEnter: inAppRouteGuard,
            },
            {
              path: '/roles/create',
              name: vueRoutes.roleCreate.name,
              component: RoleCreate,
              beforeEnter: inAppRouteGuard,
            },
          ],
        },
        {
          path: '/admin-actions',
          name: vueRoutes.adminActions.name,
          meta: {
            pageNameTranslationId: 'pages-names.admin-actions',
          },
          component: AdminActionsPage,
          // redirect: vueRoutes.rolesList,
          beforeEnter: inAppRouteGuard,
        },
        {
          path: '/widget-access-keys',
          name: vueRoutes.widgetAccessKeys.name,
          meta: {
            pageNameTranslationId: 'pages-names.widget-access-keys',
          },
          component: WidgetAccessKeyPage,
          redirect: vueRoutes.widgetAccessKeyList,
          beforeEnter: inAppRouteGuard,
          children: [
            {
              path: '/widget-access-keys/list',
              name: vueRoutes.widgetAccessKeyList.name,
              component: WidgetAccessKeyList,
              beforeEnter: inAppRouteGuard,
            },
          ],
        },
        {
          path: '/feature-flags',
          name: vueRoutes.featureFlags.name,
          meta: {
            pageNameTranslationId: 'pages-names.feature-flags',
          },
          component: FeatureFlags,
          beforeEnter: inAppRouteGuard,
        },
        {
          path: '/permission-transactions',
          name: vueRoutes.permissionTransactions.name,
          meta: {
            pageNameTranslationId: 'pages-names.permission-transactions',
          },
          component: PermissionTransactions,
          beforeEnter: inAppRouteGuard,
        },
      ],
    },
  ],
})

export default router

function authPageGuard (to, from, next) {
  const isLoggedIn = store.getters[vuexTypes.isLoggedIn]
  const isAdminAccount = store.getters[vuexTypes.isAdminAccount]
  isLoggedIn && isAdminAccount ? next(vueRoutes.app) : next()
}

function redirectRouteGuard (to, from, next) {
  const isLoggedIn = store.getters[vuexTypes.isLoggedIn]
  const isAdminAccount = store.getters[vuexTypes.isAdminAccount]
  if (isLoggedIn && isAdminAccount) {
    if (to.name === vueRoutes.app.name) {
      next(vueRoutes.dashboard)
    } else {
      next()
    }
  } else {
    next(vueRoutes.login)
  }
}

function inAppRouteGuard (to, from, next) {
  const isDisabled = _get(to, 'meta.isDisabled')

  if (isDisabled) {
    next(vueRoutes.app)
  } else {
    next()
  }
}
